// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import { LoadableAfterPaint, LoadablePaint } from '@confluence/loadable';

export const LazyTeamCalendars = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-TeamCalendars" */ './TeamCalendars.tsx'))
			.TeamCalendar,
});

export const LazyHomepageCard = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-HomepageCard" */ './HomepageCard.tsx'))
			.HomepageCard,
});

export const LazyTeamCalendarSiteSettingsPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TeamCalendarSiteSettingsPage" */ './site-settings/TeamCalendarSiteSettingsPage.tsx'
			)
		).TeamCalendarSiteSettingsPage,
});

export { ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE } from './site-settings/teamCalendarSiteSettingsConstants.ts';
export { CALENDAR_CONTEXT } from './components/TeamCalendarContextProvider.tsx';
